import { head } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useAssetActions } from '../../_actions/assetActions'
import { useAssets } from '../_load/AssetsLoader'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiSelectMenu from '../../../../packages/kiti/components/multiSelect/MultiSelectMenu'

const MultiRowsActions = () => {
  const assets = useAssets()
  const { selecteds, getSelectedData } = useMultiSelectState()
  const { t } = useTranslation()
  const selectedAssets = getSelectedData(assets)
  const [menuOptions, loading] = useAssetActions(head(selectedAssets), selecteds)

  return <MultiSelectMenu t={t} loading={loading} options={menuOptions} />
}

export default MultiRowsActions
